import type { RouterConfig } from "@nuxt/schema";

const subDomainDirectories = {
    forms: "public/forms",
    notifications: "public/notifications",
    partners: "keep:embed",
};

const excludedSubDomains = ["www", "localhost", "localhost:3000"];

export default <RouterConfig>{
    routes: (_routes) => {
        let routesDirectory: any = undefined;
        let subdomain: any = undefined;
        const { ssrContext } = useNuxtApp();
        const config = useRuntimeConfig()

        // check for subdomain in the URL on the server
        if (import.meta.server && ssrContext && ssrContext.event.node.req) {
            const request = ssrContext.event.node.req;
            subdomain = request.headers.host?.split(".")[0];
        }

        // check for subdomain in the URL on the client
        if (import.meta.client && window.location.hostname) {
            subdomain = window.location.hostname.split(".")[0];
        }

        // get matching routes directory
        if (subdomain && !excludedSubDomains.includes(subdomain)) {
            if (subdomain in subDomainDirectories) {
                routesDirectory =
                    subDomainDirectories[
                        subdomain as keyof typeof subDomainDirectories
                    ];
            }
        } else {
            routesDirectory = "default";
        }

        // function to clear a directory not in use
        function isUnderDirectory(route: any, directory: any) {
            directory = directory.split(':').reverse()[0];

            const path = route.path;

            return (
                path === "/" + directory ||
                path.startsWith("/" + directory + "/")
            );
        }

        function getSubDomain(route: any) {
            for(const subdomain of Object.keys(subDomainDirectories)) {
                if(isUnderDirectory(route, subdomain)) return subdomain;
            }

            return undefined;
        }

        let newRoutes = _routes;

        if (routesDirectory) {
            // when route is default we filter all subdomain routes out of the list
            if (!routesDirectory || routesDirectory === "default") {
                newRoutes = _routes.filter((route: any) => {
                    return (
                        Object.values(subDomainDirectories).filter(
                            (subdomain) => {
                                return isUnderDirectory(route, subdomain);
                            },
                        ).length === 0
                    );
                });
            } else {
                // filter routes to the matched directory
                newRoutes = _routes
                    .map((route: any) => {
                        route = {
                            ...route,
                            path: route.path.replace(`/${routesDirectory}`, ""),
                            name: route.name || "index"
                        }

                        if(!isUnderDirectory(route, routesDirectory)) {
                            const subdomain = getSubDomain(route);
                            const url = new URL(config.public.baseUrl);
                            url.hostname = subdomain ? `${subdomain}.${url.hostname}` : url.hostname;
                            url.pathname = route.path;

                            route = {
                                ...route,
                                to: url.href
                            }
                        }

                        return route;
                    });
            }
        }

        return newRoutes;
    },
};
